import { LinkButton } from './Button';
import { Icon } from './Icon';

/**
 * "Open this record" -- the one View button for every list in every area.
 *
 * A labelled, tinted small button: on a card it is usually the main action,
 * so it sits last (rightmost) in the footer and reads as the way in. Pass
 * `variant="secondary"` where something else on the card is the main action.
 *
 * `label` is the visible name ("View details", "View application"); `title`
 * names the record ("Open Anirban Banerjee") as the tooltip.
 */
export function ViewButton({
  to,
  title,
  label = 'View details',
  icon = 'eye',
  variant = 'tintBrand',
  className,
}) {
  return (
    <LinkButton to={to} variant={variant} size="sm" title={title} className={className}>
      <Icon name={icon} size={14} />
      {label}
    </LinkButton>
  );
}
